import { Pipe, PipeTransform } from '@angular/core';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'filterAlarmBySearchKeyword'
})
export class FilterAlarmBySearchKeywordPipe implements PipeTransform {

  transform(alarms: MonitoringAlarm[], searchKeyword: string): MonitoringAlarm[] {
    console.log(searchKeyword)
    return searchKeyword ? alarms && alarms.filter(alarm => {
      return alarm.description.includes(searchKeyword)
    }) : alarms;
  }

}
